import { useTranslate } from "@tolgee/react";

/**
 * Router-wide `defaultErrorComponent`. The main way users land here: a route
 * chunk import failed twice with the same message (stale tab after a deploy),
 * which exhausts BOTH auto-reload guards — `initPreloadErrorHandler`'s 30s
 * window and TanStack's once-per-message `lazyRouteComponent` reload — and the
 * router then throws the cached error into this boundary. Without this
 * component, TanStack's bare default error UI renders on the dark body and
 * looks like a dead crash screen with no way out. `location.reload()` is the
 * only real recovery: the failed import promise is cached at module level, so
 * `reset()` would just rethrow.
 */
export function RouteError() {
	const { t } = useTranslate();
	return (
		<div className="flex min-h-[calc(100dvh-48px)] flex-col items-center justify-center px-4 text-center">
			{/* ponytail: reuses existing login.error-generic / actions.refresh keys — new keys need tolgee:push+publish */}
			<h1 className="text-title2 text-foreground">
				{t("login.error-generic")}
			</h1>
			<button
				type="button"
				onClick={() => window.location.reload()}
				className="mt-8 inline-flex h-10 items-center rounded-md bg-primary px-5 text-body2-medium text-primary-foreground transition-colors hover:bg-primary/90"
			>
				{t("actions.refresh")}
			</button>
		</div>
	);
}
